export default __webpack_public_path__ + "052f3a5b8b70e44b239d44d708e7d46b.woff";